import { render, staticRenderFns } from "./CalibrationCertifiedTable.vue?vue&type=template&id=8fffe1ee&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./CalibrationCertifiedTable.vue?vue&type=style&index=0&id=8fffe1ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fffe1ee",
  null
  
)

export default component.exports